<template>
    <div class="contais">

        <div class="header">
            <!-- 左边的搜索栏 -->
            <div class="header_left">
                <div class="Search">
                    <el-date-picker v-model="inputDate" type="date" placeholder="选择赎当日期搜索" value-format="yyyy-MM-dd"></el-date-picker>
                     <el-button type="primary" @click="QueryDate">{{isQueryDate==true?'搜索中...':'搜索'}}</el-button>
                </div>
                <div class="Search">
                     <el-input v-model="inputName" placeholder="请输入当户姓名"></el-input>
                     <!-- <input type="text" class="inputText"> -->
                     <el-button type="primary"  @click="QueryName">{{isNameQuery==true?'搜索中...':'搜索'}}</el-button>
                </div>
            </div>
            <!-- 右边显示在当业务数量 -->
            <div class="header_right">
                <div class="header_right_a">
                    <span>今日赎当：{{DayTableData}}</span>
                    <span>金额：{{DayDataPrice}}元</span>
                </div>
                <div class="header_right_a">
                     <span>全部赎当：{{Total}}</span>
                    <span>金额：{{SumPrice}}元</span>
                </div>
            </div>
        </div>

        <!-- 内容列表 -->
        <div class="content">
             <el-table
                :data="tableData"
                border
                style="width: 100%"
                :row-class-name="tableRowClassName"
                >
                <el-table-column
                prop="CreateDate"
                label="建档日期"
                width="180">
                </el-table-column>
                <el-table-column
                prop="Piaonumber"
                label="票号"
                width="180">
                </el-table-column>
                <el-table-column
                prop="Dhname"
                label="当户姓名">
                </el-table-column>
                <el-table-column
                prop="Ddedquota"
                label="典当额度">
                </el-table-column>
                <el-table-column
                prop="DdqxStartDate"
                label="典当开始日期">
                </el-table-column>
                <el-table-column
                prop="DdqxEndDate"
                label="典当到期日期">
                </el-table-column>
                <el-table-column
                prop="ZhfPrice"
                label="典当综合费">
                </el-table-column>
                <el-table-column
                prop="lx"
                label="典当利息">
                </el-table-column>
                 <el-table-column
                prop="Fcaddres"
                label="房产地址">
                </el-table-column>
                 <el-table-column
                prop="DyfsGuaranty"
                label="抵押方式">
                </el-table-column>
                 <el-table-column
                prop="CreateUser"
                label="经办人">
                </el-table-column>
                 <el-table-column
                prop="Review"
                label="复核">
                </el-table-column>
                  <el-table-column
                prop="Finance"
                label="财务">
                </el-table-column>
            </el-table>
        </div>

    </div>
</template>
<script>
import dayjs from 'dayjs'
export default {
    name:'redeemhouse',

    data(){
        return{
            tableData:[],
            inputDate:'',
            inputName:'',
            Total:0, //赎当数量
            SumPrice:0, //赎回总金额
            DayTableData:0, //今日赎回数据
            DayDataPrice:0, //今日赎回的金额

            Dayclass:[], //今日赎回的数据

            isNameQuery:false,

            isQueryDate:false
        }
    },
    methods:{
        tableRowClassName(row){
            for(let i=0;i<this.Dayclass.length;i++){
                if(row.row.Piaonumber == this.Dayclass[i].ticketnumber){
                    return "success-row";
                }
            }
        },
        getData(){
             this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              `db.collection("house").where({Review:_.neq(""),State:"赎当"}).limit(1000).get()`,
          }).then(res=>{
              res.data.data.forEach((element,index,array)=>{
                  array[index] = JSON.parse(element)
              })
              
            //   赎回业务数量
            this.Total = res.data.pager.Total
            

            //总赎回的金额
           this.SumPrice =  this.Sum(res.data.data)

           this.tableData = res.data.data
           //今日赎回业务
           this.getDayData()

          })
        },

        //今日赎回业务数量 substr(0, 2)
        getDayData(){
             this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              `db.collection("yxus_record").where({xuday:"${dayjs().format('YYYY-MM-DD')}",stas:"赎当",}).limit(1000).get()`,
          }).then(res=>{
              res.data.data.forEach((element,index,array)=>{
                  array[index] = JSON.parse(element)
              })
            let DayData =  res.data.data.filter(item=>{
                  return item.itemname.substr(0, 2) == '房产'
              })


              this.DayTableData = DayData.length

             this.DayDataPrice =  this.Sum(DayData,'YES')

             if(DayData.length > 0){
                 this.Dayclass = DayData
             }

            
             
       
          })
        },

        //计算总赎当金额
        Sum(event,isday){
            if(isday == 'YES'){

                  let price = ''
              for (let i in event) {
                price += event[i].pri;
                price += "+";
              }
              price = price.substring(0, price.length - 1);
              return eval(price) || 0;

            }else{

                let price = ''
              for (let i in event) {
                price += event[i].Ddedquota;
                price += "+";
              }
              price = price.substring(0, price.length - 1);
              return eval(price) || 0;

            }
            
        },

        //名字查询
        QueryName(){

            this.isNameQuery = true

             this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              `db.collection("house").where({Dhname:"${this.inputName}",State:"赎当"}).limit(1000).get()`,
          }).then(res=>{
              this.isNameQuery = false
              res.data.data.forEach((element,index,array)=>{
                  array[index] = JSON.parse(element)
              })
              if(res.data.pager.Total > 0){
                  this.tableData = res.data.data
              }else{
                  this.$alert('未查询该当户的业务', '查询结果', {
                    confirmButtonText: '确定',
                    });
              }
              
          })
        },
        //日期查询
        QueryDate(){

             this.$alert('该功能未上线', '查询结果', {
                     confirmButtonText: '确定',
                     });

        }
        
    },
    created(){
                 //获取到this.ACCESS_TOKEN
     this.getTokens()

     //获取当前登录的用户数据
    this.getUserToken()

    //今日日期
    // this.day = dayjs().format('YYYY-MM-DD')
    },
    mounted(){
        setTimeout(()=>{
             this.getData()
        },1000)
       
    
    }
}
</script>
<style scoped>
.header{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content:space-between
}
.header_left{
    width: 60%;
    height: 172px;
    background: #ffffff;
    display: flex;
    flex-direction: row;
    justify-content:space-around
}
.header_right{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    width: 38%;
    height: 172px;
    background: #ffffff;
}

.header_right_a{
    width: 40%;
    height: 60%;
    background: #4f92d1;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 22px;
    font-weight: bolder;
}
.content{
    margin: 20px auto;
    width: 100%;
    /* height: 500px; */
    background: #ffffff;
}
.Search{
    width: 40%;
    height: 100%;
    display: flex;
    flex-direction: row;
  align-items: center;
}
.el-table >>> .success-row {
  background: #35be6a;
}
.inputText{
    height: 20%;
}
</style>